// Microsoft graph api to get the specific user details based on the
// given email address of that user
export async function getUserDetails(token, email) {
  const resp = await fetch(
    `https://graph.microsoft.com/v1.0/users('${email.trim()}')`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (resp.status !== 200) return null;

  let data = await resp.json();

  let id = null;
  if (data) {
    id = data.id;
  }

  return id;
}


// Microsoft graph api to add any user in the LTCP AD Group using the
// user id.
export async function addUserInAdGroup(token, id) {
  const resp = await fetch(
    "https://graph.microsoft.com/v1.0/groups/c848c213-5a5f-480d-a9ed-f32246dad3e9/members/$ref",
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        "@odata.id": `https://graph.microsoft.com/v1.0/directoryObjects/${id}`,
      }),
    }
  );

  return resp.status;
}


// Microsoft graph api to remove any user from LTCP AD Group using the
// existing user id.
export async function removeUserFromAdGroup(token, id) {
  const resp = await fetch(
    `https://graph.microsoft.com/v1.0/groups/c848c213-5a5f-480d-a9ed-f32246dad3e9/members/${id}/$ref`,
    {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  return resp.status;
}
